import Vue from 'vue'
import App from './App'
import './assets/theme/theme/index.css'
import ElementUI, {MessageBox} from 'element-ui'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import Swiper from 'vue-awesome-swiper'
import routes from './routes'
import Common from './common/js/common'
import axios from 'axios'
import filter from './filter'
import VueCookies from 'vue-cookies'
import './common/js/directives.js';
import "../src/assets/public.css"
import "../src/assets/quill-bubble.css"
import 'font-awesome/css/font-awesome.min.css'
import VueSplitter from 'vue-splitter-pane'
import VueViewer from 'v-viewer'
import reLoginCom from './components/reLogin/reloginPage'
import 'viewerjs/dist/viewer.css'
import * as filters from "./common/js/filter"
import fullCalendar from 'vue-fullcalendar'
import Decimal from 'decimal.js';

Vue.use(VueViewer)
Vue.use(VueSplitter);


Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.component('full-calendar', fullCalendar)
let ElTreeGrid = require('element-tree-grid')
Object.keys(filter).forEach(k => Vue.filter(k, filter[k]));
Vue.use(ElementUI)
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(Common)
Vue.use(VueCookies)
Vue.component(ElTreeGrid.name, ElTreeGrid)
Vue.use(Swiper)
Vue.prototype.$axios = axios
// 挂载到 Vue 原型
Vue.prototype.$decimal = Decimal;
axios.defaults.baseURL = process.env.API_ROOT
// axios.defaults.baseURL = 'http://huayang-in.com/HYIECB-v1.0'
// axios.defaults.withCredentials = false
// axios.defaults.baseURL = 'http://localhost:8080';
axios.defaults.headers.common['Authorization'] = '';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

//解决路由遗留问题 start
let pathList = ["/warrantyDetail", "/warrantyChange", "/enquiryDetail", "/noCooperation", "/managerNocooperative", "/Cooperative", "/managerCooperative", "/claimDetail",];
let routesNumMap = {
    warrantyDetail: {
        requireCase: '1',
        number: 9,
        routeName: "routeNum",
    },
    warrantyChange: {
        requireCase: '2',
        number: 9,
        routeName: "routeNum",

    },
    enquiryDetail: {
        requireCase: '3',
        number: 10,
        routeName: "enquiryRoute",
    },
    noCooperation: {
        requireCase: '4',
        number: 15,
        routeName: "userRoute",
    },
    managerNocooperative: {
        requireCase: '5',
        number: 16,
        routeName: "userMangerRoute",
    },
    Cooperative: {
        requireCase: '6',
        number: 15,
        routeName: "userRoute",
    },
    managerCooperative: {
        requireCase: '7',
        number: 16,
        routeName: "userMangerRoute",
    },
    claimDetail: {
        requireCase: '8',
        number: 5,
        routeName: "claimRouteNum",
    },
};

function setComponent(route, key) {
    switch (key) {
        case '1':
            route.component = resolve => require(["@/components/warrantyManager/warrantDetail.vue"], resolve);
            break;
        case '2':
            route.component = resolve => require(["@/components/warrantyManager/warrantyAdd.vue"], resolve);
            break;
        case '3':
            route.component = resolve => require(["@/components/enquiryManager/enquiryDetail.vue"], resolve);
            break;
        case '4':
            route.component = resolve => require(["@/components/crmMannger/noCooperation.vue"], resolve);
            break;
        case '5':
            route.component = resolve => require(["@/components/userMannger/managerNocooperative.vue"], resolve);
            break;
        case '6':
            route.component = resolve => require(["@/components/crmMannger/Cooperative.vue"], resolve);
            break;
        case '7':
            route.component = resolve => require(["@/components/userMannger/managerCooperative.vue"], resolve);
            break;
        case '8':
            route.component = resolve => require(["@/components/claimManager/claimDetail.vue"], resolve);
            break;
        default:
            console.log('传入类型错误！')
            break
    }
}

router.beforeEach((to, from, next) => {
    let path = pathList.find(e => {
        let pattern = new RegExp("^" + e);
        if (pattern.test(to["fullPath"]))
            return e;
    });


    //需要单独处理
    if (path) {
        let pattern = new RegExp("^" + path);
        path = path.substring(1);
        let flag = false;
        let arr = router.options.routes[routesNumMap[path]["number"]].children;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].path.indexOf(to["path"]) !== -1) {
                flag = true;
            }
        }

        if (!flag) {
            let routeNumber = JSON.parse(sessionStorage.getItem(routesNumMap[path]["routeName"]));
            if (routeNumber && routeNumber.length !== 0) {
                //因为添加的时候都没有判断是否已存在，会导致重复。先去重，再判断。
                let set = [];
                routeNumber.forEach(e => {
                    let exit = set.find(s => {
                        if (s.path === e.path)
                            return e;
                    });

                    if (!exit) {
                        set.push(e);
                    }
                });

                //没有则添加，一般是页面重加载丢失。
                set.forEach(e => {
                    if (pattern.test(e.path)) {
                        setComponent(e, routesNumMap[path]["requireCase"]);
                    }
                });

                router.options.routes[routesNumMap[path]["number"]].children = router.options.routes[routesNumMap[path]["number"]].children.concat(set)
                router.addRoutes(router.options.routes);
                next({...to, replace: false});
            }
        } else {
            next();
        }

        return;
    }

    if (to["path"] === '/loginForm') {
        sessionStorage.setItem('access_lose', 0);
        // this.$cookies.remove('access_token')
        localStorage.clear();
        sessionStorage.clear();
    }
    next();

})

//解决路由遗留问题 end

new Vue({
    router,
    data: function () {
        return {
            pathList: pathList, //路由处理
            routesNumMap: routesNumMap, //路由处理
            exportDisabledTime: 1000, //10秒
            customerType: [
                {label: "内贸", value: "0"},
                {label: "外贸", value: "1"},
                {label: "内外贸兼营", value: "2"},
            ], //客户类型
            pageSize: [10, 20, 40, 60, 80, 100, 200, 300], //列表查询显示记录数
        }
    },
    store,
    render: h => h(App)
}).$mount('#app')

//拼接token
axios.interceptors.request.use(
    config => {
        if (config.url.indexOf("/login") <= 0) {
            const access_token = VueCookies.get('access_token');
            if (access_token && access_token.length > 0) {
                config.headers['Authorization'] = access_token;
            }
        }
        config.headers['terminalType'] = "4";
        return config
    },
    err => {
        return Promise.reject(err)
    }
);

//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response && typeof response["headers"] !== "undefined" && typeof response["headers"]["authorization"] !== "undefined") {
            let newToken = response["headers"]["authorization"];
            VueCookies.set('access_token', newToken);
        }

        if (response && (response.errorCode == '1005' || response.data.errorCode == '2010')) {
            let item = sessionStorage.getItem('access_lose');

            if (!item || item != 1) {
                sessionStorage.setItem('access_lose', '1');
                MessageBox.alert('登录失效，请重新登录!', '操作提醒', {
                    confirmButtonText: '确定',
                    callback: action => {
                        //挂在登录弹窗组件到根节点
                        let instance = new Vue({
                            el: document.createElement("div"),
                            render: h => h(reLoginCom)
                        });

                        document.body.appendChild(instance.$el);
                    }
                });
            }
            // if (!item || item != 1) {
            //     sessionStorage.setItem('access_lose', '1');
            //
            //     MessageBox.alert('登录失效，请重新登录!', '操作提醒', {
            //         confirmButtonText: '确定',
            //         callback: action => {
            //             // 返回 401 清除token信息并跳转到登录页面
            //             // location.href ="http://localhost:7004"
            //             location.href ='http://huayang-in.com/hybb/#/loginForm'
            //             //   location.href = process.env.API_ROOT;
            //             sessionStorage.clear();
            //             localStorage.clear();
            //
            //             //
            //         }
            //     });
            //
            // }
        }
        //正常响应需要刷新本地缓存的Token
        return response;
    }
);







// WEBPACK FOOTER //
// ./src/main.js